import { render, staticRenderFns } from "./iconWhatsapp.vue?vue&type=template&id=433516fa"
import script from "./iconWhatsapp.vue?vue&type=script&lang=js"
export * from "./iconWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports